module.exports = __webpack_public_path__ + "img/adulto32.c457e1dd.jpg";